import { queryOptions, useQuery } from "tanstack-react-query-5";

import { checkSignupProcess } from "../request.auth";

type CheckSignupProcessProps = {
  email: null | string;
  hash: null | string;
};

const getCheckSignupProcessOptions = (props: CheckSignupProcessProps) => {
  const { email, hash } = props;

  return queryOptions({
    queryKey: ["checkSignupProcess", email, hash],
    queryFn: () => {
      // this should be string since we disabled the query when email or hash is null
      return checkSignupProcess({ email, hash } as { email: string; hash: string });
    },
    // staleTime 1 secs
    staleTime: 1000 * 1,
    // refetchInterval 5 secs
    refetchInterval: 1000 * 5,
    refetchOnMount: "always",
    refetchOnReconnect: "always",
    refetchOnWindowFocus: "always",
    enabled: Boolean(email && hash),
  });
};

const useCheckSignupProcess = (props: CheckSignupProcessProps) => {
  return useQuery(getCheckSignupProcessOptions(props));
};

export { getCheckSignupProcessOptions, useCheckSignupProcess };
